export default __webpack_public_path__ + "static/media/remaplist-placeholder.a72a8578.jpg";